exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".orders-table .action-bar{position:sticky;top:0;z-index:10}.orders-table-expanded{display:flex;flex-direction:column;align-content:flex-start;gap:.5rem;padding:1rem 4.5rem}.orders-table .truncated-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
